import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../store';
import SocioUpsertForm from './upsert/SocioDeNegocioUpsertForm';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ResponseError from '../../shared/responses/ResponseError';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../shared/responses/ResponseResult';

class SociosDeNegocioUpsert extends Component {

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      ...this.state,
      data: !!data.id ? { ...data } : { id, config: {} }
    }

    props.setData(data);
  }

  async componentDidMount() {
    const { data } = this.state;

    if (!!data.razon_social || !data.id) {
      return;
    }

    let info = await this.props.info(data.id);

    !!info && this.props.setData(info);;
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleOnReset = () => {
    this.props.resetError({
      error: undefined
    });
  }

  handleOnAction = (action: string) => {
    if (action === 'cancel') {
      return;
    }

    this.props.history.replace('/modulos/socios');
  }

  handleSubmit = async (action, info) => {
    const { data } = this.props;
    const body = {
      id: undefined,
      ...data
    };

    this.props.upsert(body, data.id);
  }

  handleOnFormDataChange = (event) => {
    this.props.change(event);
  }

  renderError = () => {
    const { error } = this.props;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnReset }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.props;

    return (
      <div className="result-container">
        <ResponseResult
          title="Actualización exitosa"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { data, error, result, isValid, busy, fetching } = this.props;

    if (fetching) {
      return <Loading />;
    }

    const updateLegend = !!data.id && !!data.hits ? 'Asignar hits': 'Actualizar';
    const updatingLegend = !!data.id && !!data.hits ? 'Asignando': 'Actualizando';

    return (
      <>
        { !!error && this.renderError() }

        { !!result && this.renderResult() }

        <PageHeader to="/modulos/socios" text="Socios" />

        <h5>Nuevo Socio</h5>

        <SocioUpsertForm
          data={ data }
          onFormDataChange={ this.handleOnFormDataChange }
        />

        <Row>
          <Col>
            <PopConfirm text="Quieres cancelar el registro actual?"
              onAction={ this.handleOnAction }
            >
              <Button type="button"
                variant="secondary"
                disabled={ busy }
                className="mr-3"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton type="button"
              disabled={ !isValid }
              loading={ busy }
              onClick={ this.handleSubmit }
            >
              { !!data.id ? (busy ? updatingLegend : updateLegend) : '' }
              { !data.id ? (busy ? 'Registrando...' : 'Registrar') : '' }
            </LoadingButton>
          </Col>
        </Row>

      </>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.modulo.socios.upsert,
    fetching: state.modulo.socios.info.busy,
  };
}

const mapActions = (actions) => {
  return {
    ...actions.modulo.socios.upsert,
    info: actions.modulo.socios.info.get,
    highlight: actions.modulo.socios.list.highlight
  };
}

export default connect(useStore, mapState, mapActions)(SociosDeNegocioUpsert);